module.exports = function() {
	var result = 'nta';
	if (1+2 == 3) {
		result += 'ct@thomasjac';
	}
	if (1+2 == 3) {
		result += 'ob.de';
	}
	return 'co' + result;
}
